<ui-simple-dialog-layout class="block w-full" (clickCancel)="clickCancel.emit()">
  <h2 slot="title">{{ 'cockpit.documents.uploadDialog.title' | transloco }}</h2>

  <ui-dropzone (dropFiles)="onDrop($event)">
    <ng-container slot="title">
      {{ 'cockpit.documents.uploadDialog.dropzoneTitlePrefix' | transloco }}
      <label
        class="text-primary dark:text-primary-darkmode hover:underline cursor-pointer"
        for="document-upload-dialog-input"
      >
        {{ 'cockpit.documents.uploadDialog.dropzoneTitleLink' | transloco }}
      </label>
      {{ 'cockpit.documents.uploadDialog.dropzoneTitleSuffix' | transloco }}
      <input
        type="file"
        class="hidden"
        id="document-upload-dialog-input"
        multiple
        (change)="onSelectFile($event)"
      />
    </ng-container>
    <ng-container slot="dragover-title">{{
      'cockpit.documents.uploadDialog.dropzoneDragoverTitle' | transloco
    }}</ng-container>
    <ng-container slot="subtitle">{{
      'cockpit.documents.uploadDialog.dropzoneSubtitle' | transloco
    }}</ng-container>

    @for (entry of files(); track entry.id) {
      <ui-dropzone-file
        [titleText]="entry.file.name"
        [subtitle]="entry.file.size | fileSize"
        [progress]="entry.finished ? 100 : entry.isUploading ? 50 : 0"
        [error]="entry.error"
        (clickRetry)="onClickRetry(entry.id)"
        (clickRemove)="onClickRemove(entry.id)"
      />
    }
  </ui-dropzone>

  <ui-button slot="footer" mode="outlined" (click)="clickCancel.emit()">{{
    'cockpit.documents.uploadDialog.closeButton' | transloco
  }}</ui-button>
  <ui-button
    slot="footer"
    (click)="onClickUpload()"
    [loading]="isUploading()"
    [disabled]="uploadButtonDisabled()"
    >{{ 'cockpit.documents.uploadDialog.uploadButton' | transloco }}</ui-button
  >
</ui-simple-dialog-layout>
